import React from 'react';
import propTypes from '../../../node_modules/prop-types/index.js';
import { CirclePrimitive } from './styledComponents.js';

var Circle = function Circle(_ref) {
  var color = _ref.color,
      delay = _ref.delay,
      rotate = _ref.rotate;
  return /*#__PURE__*/React.createElement(CirclePrimitive, {
    color: color,
    delay: delay,
    rotate: rotate
  });
};

process.env.NODE_ENV !== "production" ? Circle.propTypes = {
  color: propTypes.string.isRequired,
  delay: propTypes.number,
  rotate: propTypes.number
} : void 0;
Circle.defaultProps = {
  delay: undefined,
  rotate: undefined
};
process.env.NODE_ENV !== "production" ? Circle.displayName = 'Circle' : void 0;

export default Circle;
